export enum LearningPathsDropdownNameEnum {
  NAME_ASC = 'Name: A-Z',
  NAME_DESC = 'Name: Z-A',
  CREATED_NEWEST = 'Created: Newest First',
  CREATED_OLDEST = 'Created: Oldest First',
  PROGRAM_YEAR_NEWEST = 'Program Year: Newest First',
  PROGRAM_YEAR_OLDEST = 'Program Year: Oldest First',
}
